document.addEventListener('DOMContentLoaded', function () {
    var collectionExists = document.querySelector('.collection-wrapper');
    var paginationExists = document.querySelector('.pagination__list');
    //check if two elements exist
     
    if (collectionExists != null && paginationExists != null) {
      function InfiScroll() {
        // Infinite Scroll implementation!
        let elem = document.querySelector('#product-grid');
        let infScroll = new InfiniteScroll( elem, {
          // options
          path: '.pagination__next',
          append: '.collection-product-card',
          history: 'push',
          scrollThreshold: 200,
          status: '.page-load-status',
          button: '.view-more-items-button',
          debug: true
        });

        let viewMoreButton = document.querySelector('.view-more-items-button');

        infScroll.on( 'load', onPageLoad );

        function onPageLoad() {
          if ( infScroll.loadCount == 2 ) {
            // after 2nd page loaded
            // disable loading on scroll
            infScroll.options.loadOnScroll = false;
            // show button
            viewMoreButton.style.display = 'inline-block';
            // remove event listener
            infScroll.off( onPageLoad );
          }
        }
        

        infScroll.on( 'load', function( body, path, response ) {
          var currentHeaderPage = document.querySelector('.collection_page_number');
          var HeaderPage = body.querySelector('.collection_page_number').innerHTML;
          var currentPagination = document.querySelectorAll('.pagination-wrapper');
          var pageUI = body.querySelector('.pagination-wrapper').innerHTML;
          var gridContainer = body.querySelector('#product-grid');
          //var gridContainerProducts = gridContainer.querySelectorAll('.grid-product');

          if (currentHeaderPage != null) {
            currentHeaderPage.innerHTML = HeaderPage;
          }
          
          //console.log( pageUI );
          //console.log( currentPagination );
          //// replace pagination with items from response
          for (let i = 0; i < currentPagination.length; i++) {
            currentPagination[i].innerHTML = pageUI;
          }
          //currentPagination.innerHTML = pageUI;
        });

        document.addEventListener('collection:reloaded', function() {
          infScroll.destroy()
          InfiScroll();
        });
      };
      InfiScroll();
    }
});